export const DEFAULT_LOCALE = 'en-US';

export const DEFAULT_CURRENCY = 'USD';

export const INTEGER_TRAILING_ZEROS = 0;

export const DECIMAL_TRAILING_ZEROS = 2;
